<template>
  <v-alert
    v-if="shouldShow"
    :color="'warning'"
    v-model="alert"
    transition="scale-transition"
  >
    Uma nova versão do portal foi disponibilizada,
    <a href="javascript:location.reload()"
      >clique aqui para atualizar a página</a
    >.
  </v-alert>
</template>

<style lang='scss' scoped>
#jns {
  .v-alert {
    position: fixed;
    width: -webkit-fill-available;
    z-index: 50;
    border-radius: 4px;
    text-align: center;
    top: -5px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
    font-weight: bold;
  }
}
</style>

<script lang="js">
export default {
  name: "FormAlertFull",
  data: () => ({
    alert: true,
    fadeAwayInterval: false,
    timeInterval: 60 * 1000,
  }),
  computed: {
    shouldShow() {
      return true;
    },
  },

  props: {
    source: String,
    message: String,
    type: String,
  },
  
  updated() {
    if (this.shouldShow) {
      this.fadeAwayInterval = setTimeout(() => {
        this.closeButton();
      }, this.timeInterval);
    }
  },
  destroyed() {},
  methods: {
    closeButton() {
      let t = this;
      setTimeout(() => {
        clearInterval(this.fadeAwayInterval);
        t.$emit("close");
        t.alert = true;
      }, 500);
    },
  },
  watch: {
    alert: (val, oldVal) => {},
  },
};
</script>


// WEBPACK FOOTER //
// src/components/FormAlertFull.vue